import unionWith from 'lodash/unionWith';
import uniqWith from 'lodash/uniqWith';
import toString from 'lodash/toString';
import orderBy from 'lodash/orderBy';
import flatten from 'lodash/flatten';

export default function prepareWeeks(weeks, sorting) {
	const zeros = uniqWith(flatten(weeks.map((week) => week.data.map((item) => ({ ...item, value: 0 })))), isSimilarItem);

	return weeks
		.map((w) => ({
			...w,
			data: unionWith(w.data, zeros, isSimilarItem).map((item) => ({ ...item, type: getItemType(item) }))
		}))
		.map((w, i, weeks) => ({
			...w,
			data: sortList(w.data, weeks, sorting)
		}));
}

function isSimilarItem(a, b) {
	return a.region === b.region && a.country === b.country && a.affiliate === b.affiliate;
}

function getItemType(item) {
	if (!item.region && !item.country && !item.affiliate) {
		return 'general';
	}
	if (item.region && !item.country && !item.affiliate) {
		return 'region';
	}
	if (item.region && item.country && !item.affiliate) {
		return 'country';
	}
	if (item.region && item.country && item.affiliate) {
		return 'affiliate';
	}
}

function sortList(list, weeks, sorting) {
	return unwrap(sort(wrap(list, ['general', 'region', 'country', 'affiliate']), weeks, sorting));
}

function wrap(list, [type, ...types]) {
	return list.filter((item) => item.type === type).map((main) => ({
		main,
		rows: wrap(list.filter((item) => item[type] === main[type] && !!item[types[0]]), types)
	}));
}

function unwrap(rows) {
	return rows.reduce((list, { main, rows }) => list.concat(main, unwrap(rows)), []);
}

function sort(rows, weeks, sorting) {
	return rows.map(({ main, rows }) => {
		const sorted = orderBy(rows, [
			(row) => sorting.direction && weeks[sorting.index + 1].data.find((info) => isSimilarItem(row.main, info)).value,
			(row) => toString(row.main[row.main.type])
		], [sorting.direction, 'asc']);

		return {
			main,
			rows: sort(sorted, weeks, sorting)
		};
	});
}



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/weekly-report/prepare-weeks.js